import type { AjaxError } from 'rxjs/ajax';
import timeout from 'utils/http.old/middlewares/timeout';

import type { IHttpConfig, IHttpGetConfig } from './httpClient.model';
import base from './middlewares/base';
import fakeSso from './middlewares/fakeSso';
import monitor from './middlewares/monitor';
import queryParams from './middlewares/queryParams';
import redirectTokenExpired from './middlewares/redirectTokenExpired';
import sgConnect from './middlewares/sgConnect';
import { polling, signalr } from './middlewares/streams';

const baseMiddlewareArray = [base, monitor, sgConnect, timeout];
if (window?.sgmeConfiguration?.enablePolling) {
  baseMiddlewareArray.push(polling);
}
if (window?.sgmeConfiguration?.enableSignalr) {
  baseMiddlewareArray.push(signalr);
}
if (window?.sgmeConfiguration?.enableFakeSso) {
  baseMiddlewareArray.push(fakeSso);
}

const getMiddlewareArray = [...baseMiddlewareArray, queryParams];

export function applyRequestMiddlewares(config: IHttpConfig): IHttpConfig {
  const middlewares = [...baseMiddlewareArray];

  return middlewares.reduce<IHttpConfig>((currentConfig, middleware) => middleware(currentConfig), config);
}

export function applyGetMiddlewares(config: IHttpGetConfig): IHttpGetConfig {
  return getMiddlewareArray.reduce<IHttpGetConfig>((currentConfig, middleware) => middleware(currentConfig), config);
}

export const applyResponseErrorMiddlewares = () => (response: AjaxError) => {
  const middlewares = [redirectTokenExpired];

  return middlewares.reduce<any>((currentResponse, middleware) => middleware(currentResponse), response);
};
